module.exports = __webpack_public_path__ + "static/media/dong_song_text_04.972ff500.jpg";